export default __webpack_public_path__ + "static/media/ReviewSample.7afa64d4.xlsx";